/** Two-letter tile initials when the catalog has no icon. */
export const abbrFromLabel = (label: string): string => {
  const parts = label.trim().split(/\s+/).filter(Boolean);
  const first = parts[0];
  if (!first) {
    return '??';
  }
  const second = parts[1];
  if (!second) {
    return first.slice(0, 2).toUpperCase();
  }
  return `${first[0] ?? ''}${second[0] ?? ''}`.toUpperCase();
};

/** Stable fallback colour from a string id (no icon / mock colour). */
export const colorFromId = (id: string): string => {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  }
  const hue = hash % 360;
  return `hsl(${hue} 45% 40%)`;
};
